import React from "react";
import styles from "../../../../styles/catalog-places.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { Loading } from "../../../components/Loading";
import { Checkbox } from "../../../components/Checkbox";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";

const Places = {
  DELIVERY: "Delivery",
  TAKEOUT: "Retirada",
  INDOOR: "Mesas",
  TOTEM: "Totem",
  
};

export class ManagePlaces extends React.Component {
  state = {
    selectedPlaces: [],
    alreadyUsedPlaces: [],
    loading: false,
    loadingRegister: false,
  };

  async componentDidMount() {
    await this.loadPlaces();
  }

  async loadPlaces () {
    const { catalogService } = this.props;

    this.setState({ loading: true });

    const environmentId = await EnvironmentStorage.getSelectedEnvironment();

    const catalogPlaces = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "catalog_places"
    );

    if (!Object.keys(catalogPlaces).length === 0) {
      this.setState({
        selectedPlaces: [],
        alreadyUsedPlaces: []
      });
    } else {
      const selectedPlaces = catalogPlaces[catalogService] || [];

      const alreadyUsedPlaces = [];
      for (let [service, places] of Object.entries(catalogPlaces)) {
        if (service !== catalogService) {
          alreadyUsedPlaces.push(...places);
        }
      }

      this.setState({
        selectedPlaces: selectedPlaces,
        alreadyUsedPlaces: alreadyUsedPlaces
      });
    }

    this.setState({ loading: false });
  }

  async componentDidUpdate(prevProps) {
    const { catalogService } = this.props;
    if (prevProps.catalogService !== catalogService) {
      await this.loadPlaces();
    }
  }

  onTogglePlace(place) {
    const { selectedPlaces } = this.state;
    if (selectedPlaces.includes(place)) {
      this.setState({
        selectedPlaces: selectedPlaces.filter(
          (existingPlace) => existingPlace !== place
        ),
      });
    } else {
      this.setState({
        selectedPlaces: [...selectedPlaces, place],
      });
    }
  }

  async onSavePlaces() {
    const { catalogService } = this.props;
    const { selectedPlaces } = this.state;

    this.setState({
      loadingRegister: true
    });

    const environmentId = await EnvironmentStorage.getSelectedEnvironment();

    const currentPlaces = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "catalog_places"
    );

    const newPlaces = {
      ...currentPlaces,
      [catalogService]: selectedPlaces
    }

    await EnvironmentsAPI.putConfigurationsByAlias(
      environmentId,
      "catalog_places",
      newPlaces
    );

    this.setState({
      loadingRegister: false
    });
  }

  getCatalogServiceName () {
    const { catalogService } = this.props;

    const serviceNames = {
      DELIVERY: 'Delivery',
      INDOOR: 'Indoor'
    }

    return serviceNames[catalogService];
  }

  render() {
    const { open, setOpen } = this.props;
    const { selectedPlaces, loading, loadingRegister, alreadyUsedPlaces } = this.state;
    const catalogServiceName = this.getCatalogServiceName();

    return (
      <Drawer
        visible={open}
        onClose={() => setOpen(false)}
        title={"Lugares onde o cardápio está disponível"}
        footer={
          <Button
            design="primary"
            className="w-100"
            disabled={loading || loadingRegister}
            loading={loadingRegister}
            onClick={() => this.onSavePlaces()}
          >
            Salvar
          </Button>
        }
        withoutTransition
      >
        {loading && (
          <div className={styles.loading}>
            <Loading />
          </div>
        )}

        {!loading && (
          <div className={styles.placesContainer}>
            <div className={styles.instructions}>
              <div className={styles.about}>
                <p className={styles.description}>
                  Selecione os locais onde o cardápio{" "}
                  <strong className={styles.highlight}>{catalogServiceName}</strong> pode
                  ser utilizado
                </p>
              </div>
            </div>
            <div className={styles.places}>
                {Object.entries(Places).map(([placeKey, placeName]) => (
                  <>
                    <Checkbox
                      key={placeKey}
                      name={`place-${placeKey}`}
                      design="two"
                      className="mb-20"
                      disabled={alreadyUsedPlaces.includes(placeKey)}
                      checked={selectedPlaces.includes(placeKey)}
                      onChange={() => this.onTogglePlace(placeKey)}
                    >
                      {placeName}
                    </Checkbox>
                  </>
                ))}
            </div>
          </div>
        )}
      </Drawer>
    );
  }
}
